export default "__VITE_ASSET__CVyRC5ir__"